import { useEffect, useState, useMemo } from 'react'

import api from '../../../../api/api'
import { socialLinkServiceOptions } from '../../../Organisation/CommunicationPortal/helpers'

export const useSocialLinksOptions = (buildingId, refetchOnFocus) => {
  const [socialLinks, setSocialLinks] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const availableServices = useMemo(() => socialLinks.map((opt) => opt.service), [socialLinks])
  const availableOptions = useMemo(
    () =>
      socialLinkServiceOptions
        .filter((opt) => availableServices.includes(opt.value))
        .map((opt) => ({ ...opt, id: opt.value })),
    [availableServices],
  )

  const fetchSocialLinks = async () => {
    if (!buildingId) {
      return
    }

    try {
      setIsLoading(true)
      const resp = await api.fetchSocialLinks(buildingId)
      const modifiedLinks = resp.data.map((link) => ({
        value: link.id,
        label: link.link,
        ...link,
      }))
      setSocialLinks(modifiedLinks)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchSocialLinks()

    if (refetchOnFocus) {
      window.addEventListener('focus', fetchSocialLinks)
    }

    return () => {
      if (refetchOnFocus) {
        window.removeEventListener('focus', fetchSocialLinks)
      }
    }
  }, [buildingId, refetchOnFocus])

  return { socialLinks, availableOptions, isLoading }
}
